// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3KmxD","head":"Table_head__3XPBg","col":"Table_col__1P5aq"};